import { StickerState } from '@/shared/models';
export const isStickerStateRevokable = (stickerState) => stickerState < StickerState.Packed;
